import * as React from 'react';

import IllustrativeTooltip from 'bundles/program-common/components/IllustrativeTooltip/IllustrativeTooltip';
import { ProgressBar } from 'bundles/skills-common';

import _t from 'i18n!nls/program-common';

const SvgTargetProficiencyScore: React.FC<{ hideTarget?: boolean }> = ({ hideTarget }) => {
  return (
    <div style={{ width: 320 }}>
      <IllustrativeTooltip width={220} anchorLeft={21}>
        <div style={{ fontSize: 24 }}>
          <strong style={{ color: '#1F1F1F' }}>{(180).toLocaleString()}</strong>
        </div>
        <div style={{ color: '#1F1F1F', fontSize: 12, fontWeight: 'bold', marginBottom: 8 }}>
          {_t('Target score for this skill')}
        </div>
        <div style={{ color: '#757575', fontSize: 11 }}>
          {_t('Proficiency targets are indicators of skill proficiency determined by your organization')}
        </div>
      </IllustrativeTooltip>
      <ProgressBar segments={[50, 150, 350]} target={hideTarget ? undefined : 180} />
    </div>
  );
};

export default SvgTargetProficiencyScore;
